// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YbCPr","left":"styles_left__3ylPs","desktopActions":"styles_desktopActions__2tGWi","title":"styles_title__2ji6V"};